import Rest from '@/services/Rest'

export default class ProcAndPatDetailsCodingSchemaService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/procedureAndPatientDetailCodingSchemas'

}
